var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDine = function SvgDine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 31 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B0B0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.56,
    d: "M3.979 2.8v8.96a2.57 2.57 0 0 0 2.56 2.56h5.12a2.56 2.56 0 0 0 2.56-2.56V2.8M9.1 2.8v25.601M27.02 19.44v8.961m0-8.96V2.8a6.4 6.4 0 0 0-6.4 6.4v7.68a2.57 2.57 0 0 0 2.56 2.56z"
  })));
};
export default SvgDine;